import apiClient from "./apiClient";

const checkUpReviewsApi = {
  getReviewUrl: async ({ appointmentType, appointmentId }) => {
    const response = await apiClient.get(`/checkup-reviews/url/${appointmentType}/${appointmentId}`);
    return response.data;
  },
  getAnalytics: async ({ branchId, nutriologyId, startDate, endDate, jobArea } = {}) => {
    const response = await apiClient.get("/checkup-reviews/analytics/summary", {
      params: { branchId, nutriologyId, startDate, endDate, jobArea },
    });
    return response.data;
  },
  createOrUpdate: async (data) => {
    const response = await apiClient.post("/checkup-reviews", data);
    return response.data;
  },
};

export default checkUpReviewsApi;
